export var FacebookDataProviderItemType = 'FacebookDataProviderItem:#Exchange';
export var FacebookProviderScopeType = 'FacebookProviderScope:#Exchange';
export var FileAttachmentDataProviderItemType = 'FileAttachmentDataProviderItem:#Exchange';
export var FolderAttachmentDataProviderItemType = 'FolderAttachmentDataProviderItem:#Exchange';
export var GDriveDataProviderItemType = 'GDriveDataProviderItem:#Exchange';
export var OneDriveProScopeName = 'OneDriveProScope:#Exchange';
export var ScopeBreadcrumbId = 'scopeId';
export var SearchBreadcrumbId = 'searchId';
export var SizeLimitInKbToSuggestSharing = 5 * 1024;
//# sourceMappingURL=filePickerConstants.js.map